import API from '@aws-amplify/api';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { updateViewsResource } from '@/graphql/mutations';
import { getViewList, getViewDetail, getApiPublic } from '@/graphql/queries';
import {
    prepareParamsGetListViewByVisibleRange,
    prepareParamsGetListViewInProject
} from './dynamoDBRequestDto/DynamoDBViewRequestDto';

export const getListViewInProject = async (
    APIClient,
    affiliationProject,
    visibleRange,
    visibleType
) => {
    try {
        let params = prepareParamsGetListViewInProject(
            affiliationProject,
            visibleRange,
            visibleType
        );
        let expression = JSON.stringify(params);

        let result = await API.graphql({
            query: getViewList,
            variables: {
                params: {
                    expression: expression
                }
            }
        });

        // check response query
        if (Utils.isEmptyObject(result) || Utils.isEmptyArray(result.data.getViewList)) {
            return [];
        }

        return result.data.getViewList;
    } catch (err) {
        console.log('getListViewInProject error: ', err);
        return [];
    }
};

export const getListViewByOfVisibleProject = async (affiliationCorporation, affiliationProject, userId, definitionView) => {
    try {
        let result = await API.graphql({
            query: getViewList,
            variables: {
                params: {
                    userId: userId,
                    projectId: affiliationProject,
                    corporationId: affiliationCorporation,
                    isGetListViewInProject: true,
                    definitionView: definitionView
                }
            }
        });

        if (Utils.isEmptyObject(result) || Utils.isEmptyArray(result.data.getViewList)) {
            return [];
        }

        return result.data.getViewList;
    } catch (error) {
        console.log('getListViewByOfVisibleProject error: ', error);
        return [];
    }
};

export const getListViewByVisibleRange = async (
    APIClient,
    affiliationProject,
    visibleRange,
    visibleType,
    definitionView
) => {
    try {
        if (Utils.isEmptyString(definitionView)) {
            definitionView = Constant.DEFINITION_VIEW.KNOWLEDGE;
        }

        let params = prepareParamsGetListViewByVisibleRange(
            affiliationProject,
            visibleRange,
            visibleType,
            definitionView
        );

        let expression = JSON.stringify(params);

        let result = await API.graphql({
            query: getViewList,
            variables: {
                params: {
                    expression: expression,
                    projectId: affiliationProject,
                    definitionView
                }
            }
        });
        // check response query
        if (Utils.isEmptyObject(result) || Utils.isEmptyArray(result.data.getViewList)) {
            return [];
        }

        return result.data.getViewList;
    } catch (err) {
        console.log('getListViewByVisibleRange error: ', err);
        return [];
    }
};

export const getViewById = async (APIClient, id) => {
    if (!id) return {};
    try {
        let queryViewResult = await API.graphql({
            query: getViewDetail,
            variables: {
                params: {
                    id: id
                }
            }
            // authMode: Constant.AUTH_MODE_API_KEY,
        });

        if (
            Utils.isEmptyObject(queryViewResult) ||
            Utils.isEmptyObject(queryViewResult.data.getViewDetail)
        ) {
            return {};
        }

        return queryViewResult.data.getViewDetail;
    } catch (err) {
        console.log('getViewById error: ', err);
        return {};
    }
};

export const createViewData = async (APIClient, viewData) => {
    try {
        let input = {
            ...viewData
        };
        let res = await API.graphql({
            query: updateViewsResource,
            variables: {
                updateViewResourceRequestDto: {
                    method: Constant.UPDATE_VIEW_RESOURCE_METHOD.CREATE_VIEW,
                    createViewDto: JSON.stringify(input)
                }
            }
        });

        return JSON.parse(res.data?.updateViewsResource.data);
    } catch (err) {
        console.log('createViewData error: ', err);
        return null;
    }
};

export const updateViewData = async (APIClient, id, viewData) => {
    try {
        let input = {
            id,
            ...viewData
        };
        let res = await API.graphql({
            query: updateViewsResource,
            variables: {
                updateViewResourceRequestDto: {
                    method: Constant.UPDATE_VIEW_RESOURCE_METHOD.UPDATE_VIEW,
                    updateViewDto: JSON.stringify(input)
                }
            }
        });
        return res.data?.updateView;
    } catch (err) {
        console.log('updateViewData error: ', err);
        return null;
    }
};

export const deleteViewData = async (APIClient, id) => {
    try {
        let input = {
            id
        };
        let res = await API.graphql({
            query: updateViewsResource,
            variables: {
                updateViewResourceRequestDto: {
                    method: Constant.UPDATE_VIEW_RESOURCE_METHOD.DELETE_VIEW,
                    deleteViewDto: JSON.stringify(input)
                }
            }
        });
        return res.data?.deleteView;
    } catch (err) {
        console.log('deleteView error: ', err);
        return null;
    }
};

export const getListViewTabPubicKnowledge = async (APIClient, requestDto) => {
    try {
        let res = await API.graphql({
            query: getApiPublic,
            variables: {
                params: JSON.stringify(requestDto)
            },
            authMode: Constant.AUTH_MODE_API_KEY
        });
        return res.data.getApiPublic;
    } catch (error) {
        console.log('getListView err', error);
        return;
    }
};

export const editViewsResourceAPI = async (APIClient, viewData) => {
    try {
        let res = await API.graphql({
            query: updateViewsResource,
            variables: { updateViewResourceRequestDto: viewData }
        });
        let createResult = res.data?.updateViewsResource;
        return Utils.convertJSONDataToObject(createResult.data);
    } catch (error) {
        console.log('editViewsResource error: ', error);
        return null;
    }
}
